import { useFormContext } from 'react-hook-form';
import { Locales } from '@locales/en.ts';
import type { FormInput } from './CreateVirtualEVSEForm.tsx';
import { CUSTOM_HOST_VALUE } from './CreateVirtualEVSEForm.tsx';
import type { FC } from 'react';
import { FormAutocomplete } from '@components/forms/FormAutocomplete.tsx';
import { useFindHostsQuery } from '@services/queries/use-find-hosts.query.ts';

// TextField wrapper to get "host" attribute from form state
export const CustomHostTextField: FC = () => {
  const { data: hosts, isLoading: isLoadingHosts } = useFindHostsQuery();

  const { watch } = useFormContext<FormInput>();
  const selectedHost = watch('host' as keyof FormInput);

  const hostsOptions: string[] = (hosts || []).map(([, value]) => value);

  if (selectedHost !== CUSTOM_HOST_VALUE) {
    return null;
  }

  return (
    <FormAutocomplete
      name={'customHost' as keyof FormInput}
      options={hostsOptions}
      disabled={isLoadingHosts}
      freeSolo
      textFieldProps={{
        label: Locales.labels.customHost,
        placeholder: 'ws://custom.com:443/ws/ocpp16',
      }}
    />
  );
};
